<template>
    <div>
        <span class="btn btn-outline add-to-waiting-list" @click="modal = true">Сообщить о поступлении</span>

        <q-dialog
            v-model="modal"
            transition-show="scale"
            transition-hide="scale"
            :maximized="$q.platform.is.mobile"
        >
            <q-card class="modal-add-to-waiting-list">
                <div class="modal-header">
                    <div class="modal-title">Сообщить о поступлении</div>

                    <div class="modal-close" @click="modal=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10"
                                 enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="subscription-message">Мы сообщим Вам, когда нужный размер появится в наличии</div>

                    <div class="required-size-label">Нужный размер</div>

                    <div v-if="sizes && sizes.length" class="product-size">
                        <div class="product-size-items">
                            <div v-for="size in sizes" class="product-size-item"
                                 :class="{'active': isSelected(size)}"
                                 @click="toggle(size)">{{ size }}</div>
                        </div>

                        <div v-if="form.errors.has('sizes')" class="q-field--error relative-position">
                            <div class="q-field__bottom row items-start q-field__bottom--animated">
                                <div class="q-field__messages col">
                                    <div role="alert">{{ form.errors.get('sizes') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <q-input
                        outlined
                        class="required"
                        v-model="form.email"
                        @input="form.errors.clear('email')"
                        :error-message="form.errors.get('email')"
                        :error="form.errors.has('email')"
                        label="Ваш email" />

                    <q-card-actions class="q-pa-none q-mt-md">
                        <q-btn class="full-width" label="Подписаться" @click.prevent="add" />
                    </q-card-actions>

                    <div class="cart-total-accept">
                        Нажимая на кнопку «Подписаться», вы соглашаетесь на подписку и уведомления по электронной почте
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog
            v-model="success"
            transition-show="scale"
            transition-hide="scale"
            :maximized="$q.platform.is.mobile"
        >
            <q-card class="modal-add-to-waiting-list">
                <div class="modal-header">
                    <div class="modal-title">Вы успешно подписались!</div>

                    <div class="modal-close" @click="modal=false">
                        <span aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 x="0px" y="0px" width="10px" height="10px" viewBox="0 0 10 10"
                                 enable-background="new 0 0 10 10" xml:space="preserve">
                                <path fill=""
                                      d="M5.429,5l4.478-4.472c0.116-0.118,0.116-0.31,0-0.428c-0.119-0.118-0.31-0.118-0.429-0.001L5,4.571 L0.522,0.099C0.404-0.019,0.212-0.018,0.093,0.1c-0.117,0.118-0.117,0.31,0,0.428L4.571,5L0.094,9.471 c-0.117,0.118-0.117,0.31,0,0.427c0.06,0.062,0.138,0.09,0.215,0.09c0.078,0,0.154-0.028,0.214-0.088L5,5.428l4.479,4.473 c0.059,0.06,0.137,0.088,0.215,0.088c0.076,0,0.155-0.028,0.214-0.09c0.116-0.117,0.116-0.309,0-0.427L5.429,5z"></path>
                            </svg>
                        </span>
                    </div>
                </div>
                <q-card-section class="modal-content">
                    <div class="subscription-message">
                        Как только товар появится в наличии, мы вам сообщим по указанному email.
                    </div>

                    <q-card-actions class="q-pa-none q-mt-md">
                        <q-btn class="full-width" label="Хорошо" @click.prevent="success = false" />
                    </q-card-actions>
                </q-card-section>
            </q-card>
        </q-dialog>
    </div>
</template>

<script>
import { Form } from "../../classes/Form";
import { mapState } from 'vuex';

export default {
    name: "AddToWaitingList",
    props: {
        product: {
            required: true,
            type: Object
        },
        sizes: {
            required: false,
            type: Array,
            default: []
        }
    },
    data() {
        return {
            modal: false,
            success: false,
            failed: false,
            form: new Form({
                product_id: this.product.id,
                size_required: this.product.size_required,
                email: '',
                sizes: []
            })
        }
    },
    mounted() {
        if (this.user && this.user.email) {
            this.form.email = this.user.email;
        }

        if ((window.location.hash.substr(1) === 'addToWaitingList') && this.logged) {
            this.modal = true;
        }
    },
    watch: {
        user(newValue) {
            if (newValue) {
                this.form.email = this.user.email;
            }
        }
    },
    methods: {
        isSelected (size) {
            return this.form.sizes.indexOf(size) !== -1;
        },
        toggle (size) {
            this.form.errors.clear('sizes');

            if (this.isSelected(size)) {
                this.form.sizes.splice(this.form.sizes.indexOf(size), 1);
            } else {
                this.form.sizes.push(size);
            }
        },
        add() {
            this.form.post('/waiting-lists')
                .then(response => {
                    if (response.status === 'success') {
                        this.modal = false;

                        this.success = true;
                    } else {
                        alert(response.message);
                    }
                })
                .catch(error => {
                    console.log(error);
                    alert(error.message);
                })
            // this.$root.switchFavorites(this.productId)
        }
    },
    computed: {
        ...mapState('auth', ['user', 'logged']),

        /*isFavorite() {
            return this.$root.isFavorite(this.productId);
        },*/
    },
}
</script>

<style scoped>
.product-size-items {
    margin-bottom: 0;
}
.product-size {
    margin-bottom: 0;
    padding-bottom: 20px;
}
</style>
